export default {
  common: {
    backToLogin: '← Back to login',
    backToStore: 'Back to store',
    footer: {
      copyright: '© {year} KeyzoStore. All rights reserved.',
      terms: 'Terms of service',
      privacy: 'Privacy policy',
      cookies: 'Cookie policy',
    },
    logo: {
      ariaLabel: 'KeyzoStore — home',
      alt: 'KeyzoStore',
    },
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    captchaRequired: 'Please complete the verification.',
    // vue-i18n reads a bare "@" as linked-message syntax; {'@'} is the literal escape.
    emailPlaceholder: "name{'@'}example.com",
  },

  // Keys match LoginIssue / ForgotIssue in components/auth/login-validation.ts.
  validation: {
    missingBoth: 'Please enter your email address and password.',
    missingEmail: 'Please enter your email address.',
    missingPassword: 'Please enter your password.',
    invalidEmail: 'Please enter a valid email address.',
    invalidEmailMissingPassword: 'Please enter a valid email address and your password.',
  },

  password: {
    hint: 'Min 8 characters, must contain at least one letter and one digit',
    strength: {
      weak: 'Weak',
      fair: 'Fair',
      good: 'Good',
      strong: 'Strong',
    },
  },

  login: {
    heading: 'Welcome back',
    subtitle: 'Log in to access your keys, orders, and wallet',
    emailLabel: 'Email address',
    passwordLabel: 'Password',
    forgotPassword: 'Forgot password?',
    submit: 'Log in',
    submitting: 'Signing in…',
    noAccount: "Don't have an account?",
    signUp: 'Sign up',
    errorFallback: 'Login failed',
    invalidCredentials: 'Incorrect email or password.',

    forgot: {
      heading: 'Reset your password',
      subtitle: "Enter your email and we'll send a reset link",
      emailLabel: 'Email address',
      submit: 'Send reset link',
      submitting: 'Sending…',
      errorFallback: 'Could not send reset email',
    },

    sent: {
      heading: 'Check your inbox',
      subtitle: "We've sent a reset link to your email",
      openMail: 'Open email app',
    },
  },

  register: {
    heading: 'Create your account',
    subtitle: 'Join thousands of gamers buying keys at fair European prices',
    emailLabel: 'Email address',
    emailPlaceholder: "you{'@'}example.com",
    passwordLabel: 'Password',
    termsText: 'I agree to the',
    termsLink: 'Terms & Conditions',
    and: 'and',
    privacyLink: 'Privacy Policy',
    alreadyAccount: 'Already have an account?',
    signIn: 'Log in',
    submit: 'Create account',
    submitting: 'Creating…',
    errorTerms: 'You must agree to the Terms & Conditions and Privacy Policy.',
    errorPassword: 'Password must be at least 8 characters and contain a letter and a digit.',
    errorCaptcha: 'Please complete the verification.',
    errorFallback: 'Registration failed',
  },

  reset: {
    heading: 'Reset your password',
    subtitle: 'Choose a new password for your account.',
    newPasswordLabel: 'New password',
    confirmLabel: 'Confirm new password',
    mismatch: "Passwords don't match yet.",
    submit: 'Reset password',
    submitting: 'Saving…',
    errorPassword: 'Password must be at least 8 characters and contain a letter and a digit.',
    errorMismatch: 'Passwords do not match.',
    errorCaptcha: 'Please complete the verification.',
    errorExpired: 'This link has expired or is invalid.',
    errorMissingToken: 'Missing reset token. Use the link in your reset email.',
    invalidToken: {
      heading: 'Link is no longer valid',
      backToLogin: 'Back to login',
    },
    success: {
      heading: 'Password updated',
      body: 'You can now sign in with your new password. Other sessions have been signed out for safety.',
      continueToLogin: 'Continue to login',
    },
  },

  verify: {
    verifying: {
      heading: 'Verifying your email…',
      body: 'One moment while we confirm the link.',
    },
    success: {
      heading: 'Email verified!',
      bodyKyc: 'Your email is now confirmed. You can purchase items up to €50. For larger purchases, complete KYC in your account.',
      bodyNoKyc: "Your email is now confirmed. You're all set to start shopping.",
      goToDashboard: 'Go to dashboard',
      browseCatalog: 'Browse catalog →',
    },
    error: {
      heading: 'Verification link expired',
      missingToken: 'Missing verification token. The link may have been pasted incorrectly.',
      expiredFallback: 'This link has expired or is invalid. Verification links are valid for 24 hours.',
      resend: 'Resend verification email',
      resendSent: 'Verification email sent',
      sentConfirmation: 'Verification email sent. Check your inbox.',
      backToLogin: '← Back to login',
    },
  },
};
